import { render, staticRenderFns } from "./orderLife.vue?vue&type=template&id=7b4c6b82&scoped=true"
import script from "./orderLife.vue?vue&type=script&lang=js"
export * from "./orderLife.vue?vue&type=script&lang=js"
import style0 from "./orderLife.vue?vue&type=style&index=0&id=7b4c6b82&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4c6b82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b4c6b82')) {
      api.createRecord('7b4c6b82', component.options)
    } else {
      api.reload('7b4c6b82', component.options)
    }
    module.hot.accept("./orderLife.vue?vue&type=template&id=7b4c6b82&scoped=true", function () {
      api.rerender('7b4c6b82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderLife.vue"
export default component.exports